<template>
  <section>
    <div class="container is-grid no-bottom-mobile">
      <div class="is-col-12-md">
        <h1>Sign Up</h1>
        <h2>You’re one step closer to becoming a Sun Hero</h2>
        <p>
          Once you sign up, we provide you with an educator kit complete with branded Sun Heroes items, a full
          curriculum guide, and fun educational materials to use in the classroom. You also get kits for each student
          filled with sun-protection swag and SPF products for the kids to take home. The best part is, you can get
          started right now. Identify a school or program in your area. Order your kits. Practice your most heroic
          poses. Get ready to motivate change. </p>
      </div>
      <div class="is-col-12-md">
        <div class="is-col-8-md is-col-12-sm form-container">
          <form id="signupForm" @submit.prevent="sendFormData()">
            <div class="signup-form">
              <div class="form-field">
                <div class="form-row">
                  <label><span>*</span>First name</label> <input class="input-field" name="firstname"
                                                                 v-model="firstName" type="text"
                                                                 :class="{ invalid: errors.first_name }"
                                                                 @input="clear_error('first_name')"/> <span
                  class="errorMsg-text" v-if="errors.first_name">{{
                    errors.first_name[0]
                  }}</span>
                </div>
                <div class="form-row">
                  <label><span>*</span>Last name</label> <input class="input-field" name="lastname" v-model="lastName"
                                                                type="text" :class="{ invalid: errors.last_name }"
                                                                @input="clear_error('last_name')"/> <span
                  class="errorMsg-text" v-if="errors.last_name">{{
                    errors.last_name[0]
                  }}</span>
                </div>
              </div>
              <div class="form-field">
                <div class="form-row">
                  <label><span>*</span>Email address</label> <input class="input-field" name="email" v-model="email"
                                                                    type="text" :class="{ invalid: errors.email }"
                                                                    @input="clear_error('email')"/> <span
                  class="errorMsg-text" v-if="errors.email">{{
                    errors.email[0]
                  }}</span>
                </div>
                <div class="form-row">
                  <label><span>*</span>Phone number</label> <input class="input-field" name="phonenumber"
                                                                   v-model="phoneNumber" v-maska="'(###) ###-####'"
                                                                   placeholder="(###) ###-####" type="tel"
                                                                   :class="{ invalid: errors.phone }"
                                                                   @input="clear_error('phone')"/> <span
                  class="errorMsg-text" v-if="errors.phone">{{
                    errors.phone[0]
                  }}</span>
                </div>
              </div>
              <div class="form-field">
                <div class="form-row">
                  <label><span>*</span>Specialty</label>
                  <div class="selectField">
                    <select v-model="specialty" :class="{ invalid: errors.specialty }"
                            @input="clear_error('specialty')">
                      <option value="" disabled>Please select</option>
                      <option v-for="spec in $store.state.specialties" :key="spec" v-html="spec"/>
                    </select>
                  </div>
                  <span class="errorMsg-text" v-if="errors.specialty">{{
                      errors.specialty[0]
                    }}</span>
                </div>
                <div class="form-row">
                  <label><span>*</span>NPI Number</label> <input class="input-field" v-model="npiStateNumber"
                                                                 type="text"
                                                                 :class="{ invalid: errors.npi_state_license_num }"
                                                                 @input="clear_error('npi_state_license_num')"
                                                                 @blur="checkExistingUser()"/> <span
                  class="errorMsg-text" v-if="errors.npi_state_license_num">Invalid NPI number</span>
                </div>
              </div>
              <div class="form-field">
                <div class="form-row">
                  <label><span>*</span>Practice name</label> <input class="input-field" v-model="practiceName"
                                                                    type="text"
                                                                    :class="{ invalid: errors.practice_name }"
                                                                    @input="clear_error('practice_name')"/> <span
                  class="errorMsg-text" v-if="errors.practice_name">{{
                    errors.practice_name[0]
                  }}</span>
                </div>
                <div class="form-row">
                  <label><span>*</span>Practice zip code</label> <input class="input-field" v-model="zipCode"
                                                                        type="text"
                                                                        :class="{ invalid: errors.practice_zip_code }"
                                                                        @input="clear_error('practice_zip_code')"/>
                  <span class="errorMsg-text" v-if="errors.practice_zip_code">{{
                      errors.practice_zip_code[0]
                    }}</span>
                </div>
              </div>
              <div class="form-field">
                <div class="form-row">
                  <label><span>*</span>Create password</label> <input class="input-field" v-model="createPassword"
                                                                      type="password"
                                                                      :class="{ invalid: errors.password }"
                                                                      @input="clear_error('password')"/> <span
                  class="errorMsg-text" v-if="errors.password">{{
                    errors.password
                  }}</span>
                </div>
                <div class="form-row">
                  <label><span>*</span>Confirm password</label> <input class="input-field" v-model="confirmPassword"
                                                                       type="password"
                                                                       @input="clear_error('confirm_password')" :class="{
                      invalid:
                        errors.confirm_password ||
                        confirmPassword != createPassword,
                    }"/> <span class="errorMsg-text" v-if="errors.confirm_password">{{
                    errors.confirm_password[0]
                  }}</span>
                </div>
              </div>
              <div>
                <p class="errorMsg-text" v-if="errors.length != 0">
                  Please check the fields above and resubmit the form. </p>
                <p class="errorMsg-text" v-if="errorMsg.length > 0" v-html="errorMsg"></p>
                <p class="footnote">
                  Fields marked with an asterisk are required. </p>
                <div class="submit-button-container">
                  <button>
                    Sign Up <span><i class="fas fa-caret-right"></i></span>
                  </button>
                  <div class="loader-container" v-show="showLoader">
                    <img src="@/assets/images/global/loader.gif" alt=""/>
                  </div>
                </div>
                <div class="super-hero-img-mobile">
                  <img src="@/assets/images/global/Super-Steph-SunHero-300-V1.png" alt=""/>
                </div>
              </div>
            </div>
          </form>
          <div class="is-col-4-md">
            <div class="super-hero-img-lg">
              <img src="@/assets/images/global/Super-Steph-SunHero-300-V1.png" alt=""/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="existingUserModal" v-if="showModal">
      <h2>User already exists</h2>
      <p>An account with this NPI number already exists.<br><a href="/forgotpassword" class="paragraph-link">Forgot your
        password?</a></p>
      <p>Have you recently changed your email address?<br><a href="/contact" class="paragraph-link">Contact us</a>.</p>
      <button @click="showModal=false">
        CLOSE <span><i class="fas fa-times"></i></span>
      </button>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      createPassword: '',
      confirmPassword: '',
      specialty: '',
      licenseNumber: '',
      phoneNumber: '',
      npiStateNumber: '',
      practiceName: '',
      zipCode: '',
      errors: [],
      errorMsg: '',
      showLoader: false,
      showModal: false,
    }
  },
  methods: {
    clear_error (field) {
      if (typeof this.errors[field] !== 'undefined') {
        delete this.errors[field]
      }
    },
    checkExistingUser () {
      const _this = this
      _this.axios.get(
        _this.$apiUrl + 'v1/checkForExistingUser?npi_state_license_num=' + _this.npiStateNumber + '&email=' +
        _this.email).then(function (response) {
        if (response.data.errors.length === 0) {
          if (response.data.message == 'true') {
            _this.showModal = true
          }
        }
      }).catch(function () {})
    },
    sendFormData () {
      const _this = this
      _this.showLoader = true
      _this.axios.post(_this.$apiUrl + 'v1/register', {
        first_name: _this.firstName,
        last_name: _this.lastName,
        email: _this.email,
        password: _this.createPassword,
        confirm_password: _this.confirmPassword,
        phone: _this.phoneNumber.replace(/\D/g, ''),
        specialty: _this.specialty,
        npi_state_license_num: _this.npiStateNumber,
        practice_name: _this.practiceName,
        practice_zip_code: _this.zipCode,
        headers: _this.$store.state.axiosConfig.headers,
      }).then(function (response) {
        if (response.data.errors.length === 0) {
          // Copied from LogInPage.vue -- not ideal, but works for now.
          if (response.data.npi_status) {
            // Account created because NPI number validated
            _this.axios.post(_this.$apiUrl + 'v1/login', {
              email: _this.email,
              password: _this.createPassword,
            }).then(function (response) {
              if (response.data.errors.length === 0) {
                _this.$store.state.loginEmail = _this.email
                response.data.email = _this.email
                _this.$store.commit('SET_TOKEN', response.data)
                _this.$router.push({
                  name: 'SignUpThanks',
                  params: { npi_status: true },
                }).catch(() => {})
              } else {
                _this.errors = response.data.errors
                _this.showLoader = false
                // TODO: Add error output above
              }
              // _this.showResponse = true;
            }).catch(function (error) {
              _this.errors = error.response.data.errors
            })
          } else {
            // NPI number requires manual validation -- do not log in but still redirect to
            // thank you page with a different message

            _this.$router.push({
              name: 'SignUpThanks',
              params: { npi_status: false },
            }).catch(() => {})
          }
        } else {
          _this.errors = response.errors

          // TODO: Add error output above
        }
      }).catch(function (error) {
        if (error.response && error.response.status == 409) {
          _this.errors = error.response.data.errors
          _this.showLoader = false
          setTimeout(() => {
            document.querySelector('input.invalid,select.invalid').focus()
          }, 200)
        } else {
          _this.errors = []
          _this.errorMsg = error
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

h1 {
  font-size: 60px;
  text-align: left;
  margin-top: 60px;
  text-transform: uppercase;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    margin-top: 1.1em;
    font-size: 45px;
    text-align: center;
  }
}

h2 {
  font-size: 22px;
}

p {
  font-size: 16px;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    width: 100%;
    margin-bottom: 20px;
  }

  &.footnote {
    width: 100%;
  }
}

#existingUserModal {
  position: fixed;
  top: 200px;
  width: 500px;
  max-width: 95%;
  max-height: 95%;
  left: 50%;
  margin-left: -250px;
  padding: 30px;
  z-index: 1000;
  border-radius: 10px;
  background-color: white;
  box-shadow: #110f2e 0 0 10px;
  @media screen and (max-width: 768px) {
    width: 90%;
    top: 50px;
    margin-left: -45%;
  }
}

button {
  margin-top: 40px;
  background-color: @color-orange;
  font-weight: 700;
  font-family: @open-sans-font;
  font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
  text-transform: uppercase;
  border: none;
  padding: 1rem 1rem 1rem 1rem;
  cursor: pointer;

  span {
    margin-left: 10px;
  }

  @media screen and (max-width: 1000px) {
    font-size: 15px;
  }

  .fa-xmark-right {
    margin-left: 7px;
    @media screen and (max-width: 1000px) {
      margin-left: 3px;
    }
  }

}

.container {
  //padding-left: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    padding-left: 20px;
    padding-right: 20px;
  }
}

.form-field {
  display: flex;
  flex-direction: row;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    flex-direction: column;
  }
}

.form-container {
  display: flex;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    flex-direction: column;
  }
}

.form-row {
  display: flex;
  flex-flow: column wrap;

  @media screen and (min-width: 768px) {
    margin-right: 20px;
  }
  margin-bottom: 2.5rem;
}

.signup-form {
  display: flex;
  flex-flow: row wrap;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
}

.input-field {
  width: 34.6rem;
  height: 4.5rem;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-family: @open-sans-font;
  font-size: 14px;
  color: @color-txt-blue;
  box-shadow: inset 0 0 10px fade(black, 5%);
  border: 1px solid #b1b1b1;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    width: 100%;
  }

  // @media screen and (max-width: ~"@{mq-xs-bp}") {
  //   width: 31rem;
  // }
}

select {
  width: 34.6rem;
  height: 4.5rem;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-family: @open-sans-font;
  font-weight: 400;
  font-size: 14px;
  color: @color-txt-blue;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    width: 100%;
  }
}

.submit-button-container {
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    width: 48%;
  }
}

.super-hero-img-lg {
  width: 334px;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    display: none;
  }

  img {
    width: 334px;
  }
}

.super-hero-img-mobile {
  width: 71px;
  display: none;
  position: relative;
  top: -60px;
  left: 78%;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    display: block;
  }

  img {
    width: 71px;
  }
}

button {
  margin-top: 20px;
  background-color: @color-orange;
  font-weight: 700;
  font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
  font-family: @open-sans-font;
  text-transform: uppercase;
  border: none;
  padding: 1rem 1rem 1rem 1rem;
  cursor: pointer;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    padding: 1rem 0.25rem 1rem 0.25rem;
    font-size: .clampedWrem(4, @md-bp, @large-bp) [ @result];
  }

  span {
    margin-left: 10px;
  }
}

.footnote {
  font-size: .clampedW(2, @md-bp, @large-bp) [ @result];
  line-height: 1.2;
  color: #000;
}

.submit-button-container {
  display: flex;
}

.loader-container {
  position: relative;
  top: 20px;
  left: 40px;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    left: 100px;
  }
}
</style>
